"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledTimeline = exports.StyledContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _userflow = require("../../../../../../utils/userflow");
var _Button = _interopRequireDefault(require("../../../../../Button"));
var _CallIcon = _interopRequireDefault(require("../../../../../CallIcon"));
var _CallReason = _interopRequireDefault(require("../../../../Calls/CallReason"));
var _CallReasons = _interopRequireDefault(require("../../../../Calls/CallReasons"));
var _Duration = _interopRequireDefault(require("../../../../../Duration"));
var _Name = _interopRequireDefault(require("../../../../Clients/Name"));
var _Note = _interopRequireDefault(require("../../../../Notes/Note"));
var _TicketType = _interopRequireWildcard(require("../../../../Tickets/TicketType"));
var _TimeFrom = _interopRequireDefault(require("../../../../Common/TimeFrom"));
var _Timer = _interopRequireDefault(require("../../../../../Timer"));
var _Messenger = _interopRequireDefault(require("../../../../Chains/Messenger"));
var _communication = require("../../../../../../icons-react/communication");
var _iconsReact = require("../../../../../../icons-react");
var _date = require("../../../../../../utils/date");
var _constants = require("../../../../../../constants");
var _excluded = ["call", "email", "name", "note", "group", "text", "type", "read", "ticketId", "selectedCallId", "ticketType", "time"],
  _excluded2 = ["isActive", "isAnswered", "isBot", "isCallback", "isIncoming", "onPin", "pinned", "type", "messengerType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UPDATE_INTERVAL = 1 * 1000;
var CLASS_NAME_POPED_FORM = 'poped_form';
var MESSAGE_COUNT_PLURALIZE = ['сообщение', 'сообщения', 'сообщений'];
var defaultProps = {
  active: false,
  className: '',
  ticketType: _TicketType.TYPES.UNKNOWN,
  read: false
};
var ClientLog = /*#__PURE__*/function (_React$PureComponent) {
  function ClientLog(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ClientLog);
    _this = _callSuper(this, ClientLog, [props]);
    _this.communicationRef = void 0;
    _this.reasonsRef = void 0;
    _this.wrapperRef = void 0;
    _this.interval = void 0;
    var type = props.type;
    _this.state = {
      isEditing: false,
      isEditableExpired: _this.isExpired(),
      selectedReasonGroupId: null
    };
    if (type === _constants.CLIENT_LOG_TYPES.CALL) {
      _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
      _this.handleReasonDelete = _this.handleReasonDelete.bind(_this);
      _this.handleReasonsSubmit = _this.handleReasonsSubmit.bind(_this);
    }
    if (type === _constants.CLIENT_LOG_TYPES.NOTE) {
      _this.togglePin = _this.togglePin.bind(_this);
      _this.handleDelete = _this.handleDelete.bind(_this);
      _this.handleNoteEdit = _this.handleNoteEdit.bind(_this);
    }
    _this.interval = 0;
    _this.communicationRef = /*#__PURE__*/_react["default"].createRef();
    _this.reasonsRef = /*#__PURE__*/_react["default"].createRef();
    _this.wrapperRef = /*#__PURE__*/_react["default"].createRef();
    _this.toggleEdit = _this.toggleEdit.bind(_this);
    _this.handleIconClick = _this.handleIconClick.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(ClientLog, _React$PureComponent);
  return (0, _createClass2["default"])(ClientLog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        note = _this$props.note,
        call = _this$props.call;
      var isEditable = !!(0, _get2["default"])(call || note, 'editable');
      var hasExpirationTime = !!(0, _get2["default"])(call || note, 'editableExpiresAt');
      if (isEditable && hasExpirationTime && !this.isExpired()) {
        this.interval = setInterval(this.checkExpired.bind(this), UPDATE_INTERVAL);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isEditableExpired = this.state.isEditableExpired;
      var onExpiredEditable = this.props.onExpiredEditable;
      if (isEditableExpired !== prevState.isEditableExpired) {
        // TODO: Replace setTimeout
        setTimeout(onExpiredEditable);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: "handleDelete",
    value: function handleDelete() {
      var _this$props2 = this.props,
        note = _this$props2.note,
        onDelete = _this$props2.onDelete;
      var id = (0, _get2["default"])(note, 'id');
      if (id && onDelete) {
        onDelete({
          id: id
        });
      }
    }
  }, {
    key: "handleOutsideClick",
    value: function handleOutsideClick() {
      var onClickOutside = this.props.onClickOutside;
      var preventScroll = this.state.isEditing;
      var communicationBottom = 0;
      if (preventScroll) {
        var reasonsForm = this.reasonsRef.current;
        if (reasonsForm) {
          communicationBottom += reasonsForm.offsetHeight;
        }
        if (this.communicationRef) {
          var el = this.communicationRef.current;
          if (el) {
            communicationBottom += el.getBoundingClientRect().top;
            communicationBottom += el.offsetHeight;
          }
        }
      }
      onClickOutside({
        communicationBottom: communicationBottom,
        preventScroll: preventScroll
      });
    }
  }, {
    key: "handleNoteEdit",
    value: function handleNoteEdit(_ref) {
      var value = _ref.value;
      var _this$props3 = this.props,
        note = _this$props3.note,
        onEdit = _this$props3.onEdit;
      var id = (0, _get2["default"])(note, 'id');
      if (id && onEdit) {
        onEdit({
          id: id,
          value: value,
          relateTo: _constants.LOG_RELATIONS.CLIENT
        });
      }
    }
  }, {
    key: "handleIconClick",
    value: function handleIconClick() {
      var _this$props4 = this.props,
        call = _this$props4.call,
        email = _this$props4.email,
        type = _this$props4.type,
        ticketId = _this$props4.ticketId,
        onClickIcon = _this$props4.onClickIcon;
      var node = email || call;
      var id = String((0, _get2["default"])(node, 'id'));
      var isBot = (0, _get2["default"])(node, 'isBot');
      if (id && type) {
        onClickIcon({
          id: id,
          type: type,
          isBot: isBot,
          ticketId: ticketId
        });
      }
    }
  }, {
    key: "handleReasonGroupEdit",
    value: function handleReasonGroupEdit(_ref2) {
      var selectedReasonGroupId = _ref2.selectedReasonGroupId;
      this.setState({
        selectedReasonGroupId: selectedReasonGroupId
      }, this.toggleEdit);
    }
  }, {
    key: "handleReasonDelete",
    value: function handleReasonDelete(data) {
      var _this$props5 = this.props,
        call = _this$props5.call,
        onReasonDelete = _this$props5.onReasonDelete;
      var callId = (0, _get2["default"])(call, 'id');
      onReasonDelete(_objectSpread(_objectSpread({}, data), {}, {
        callId: callId
      }));
    }
  }, {
    key: "handleReasonsSubmit",
    value: function handleReasonsSubmit(data) {
      var _this$props6 = this.props,
        call = _this$props6.call,
        onReasonSubmit = _this$props6.onReasonSubmit;
      var callId = (0, _get2["default"])(call, 'id');
      onReasonSubmit(_objectSpread(_objectSpread({}, data), {}, {
        callId: callId
      }));
      this.toggleEdit();
    }
  }, {
    key: "togglePin",
    value: function togglePin() {
      var _this$props7 = this.props,
        note = _this$props7.note,
        onPin = _this$props7.onPin;
      var id = (0, _get2["default"])(note, 'id');
      var isPinned = (0, _get2["default"])(note, 'isPinned');
      if (id && onPin) {
        onPin({
          id: id,
          isPinned: !isPinned,
          relateTo: _constants.LOG_RELATIONS.CLIENT
        });
      }
    }
  }, {
    key: "toggleEdit",
    value: function toggleEdit() {
      this.setState(function (prevState) {
        return {
          isEditing: !prevState.isEditing
        };
      }, this.handleOutsideClick);
    }
  }, {
    key: "isExpired",
    value: function isExpired() {
      var _this$props8 = this.props,
        note = _this$props8.note,
        call = _this$props8.call;
      var editExpitationTime = (0, _get2["default"])(call || note, 'editableExpiresAt') || null;
      return Boolean(editExpitationTime && Date.now() >= editExpitationTime * 1000);
    }
  }, {
    key: "checkExpired",
    value: function checkExpired() {
      if (this.isExpired()) {
        clearInterval(this.interval);
        this.setState({
          isEditableExpired: true
        });
      }
    }
  }, {
    key: "reasonListRenderer",
    value: function reasonListRenderer(isEditable) {
      var _this2 = this;
      var call = this.props.call;
      var isEditing = this.state.isEditing;
      var reasonGroups = (0, _get2["default"])(call, 'reasonGroups');
      var reasons = (0, _get2["default"])(call, 'reasons');
      var selectedReasonIds = (0, _get2["default"])(call, 'selectedReasonIds') || [];
      var selectedGroups = {};
      selectedReasonIds.forEach(function (value) {
        var reason = (0, _find2["default"])(reasons, {
          value: value
        });
        if (reason) {
          var groupId = reason.groupId;
          var existingReasons = selectedGroups[groupId] || [];
          existingReasons.push(reason);
          selectedGroups[groupId] = existingReasons;
        }
      });
      return Object.keys(selectedGroups).map(function (id) {
        var reason = (0, _find2["default"])(reasonGroups, {
          value: id
        });
        if (reason) {
          var title = reason.title,
            value = reason.value;
          var groupReasons = selectedGroups[id];
          return /*#__PURE__*/_react["default"].createElement(StyledReason, {
            key: title,
            type: title,
            reasons: groupReasons,
            readOnly: !isEditable || isEditing,
            onDelete: _this2.handleReasonDelete,
            onEditToggle: function onEditToggle() {
              return _this2.handleReasonGroupEdit({
                selectedReasonGroupId: value
              });
            }
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
        call = _this$props9.call,
        email = _this$props9.email,
        name = _this$props9.name,
        note = _this$props9.note,
        group = _this$props9.group,
        text = _this$props9.text,
        type = _this$props9.type,
        read = _this$props9.read,
        ticketId = _this$props9.ticketId,
        selectedCallId = _this$props9.selectedCallId,
        _this$props9$ticketTy = _this$props9.ticketType,
        ticketType = _this$props9$ticketTy === void 0 ? _TicketType.TYPES.UNKNOWN : _this$props9$ticketTy,
        time = _this$props9.time,
        props = (0, _objectWithoutProperties2["default"])(_this$props9, _excluded);
      var _this$state = this.state,
        isEditing = _this$state.isEditing,
        isEditableExpired = _this$state.isEditableExpired,
        selectedReasonGroupId = _this$state.selectedReasonGroupId;
      var callId = (0, _get2["default"])(call, 'id');
      var answeredAt = (0, _get2["default"])(call, 'answeredAt');
      var callUrl = (0, _get2["default"])(call, 'callUrl');
      var finishedAt = (0, _get2["default"])(call, 'finishedAt');
      var isAnswered = (0, _get2["default"])(call, 'isAnswered');
      var isCallback = (0, _get2["default"])(call, 'isCallback');
      var isIncoming = (0, _get2["default"])(call, 'isIncoming');
      var reasonDescription = (0, _get2["default"])(call, 'reasonDescription');
      var reasonGroups = (0, _get2["default"])(call, 'reasonGroups') || [];
      var reasons = (0, _get2["default"])(call, 'reasons');
      var recordUrl = (0, _get2["default"])(call, 'recordUrl');
      var requireNoteIds = (0, _get2["default"])(call, 'requireNoteIds');
      var segments = (0, _get2["default"])(call, 'segments');
      var selectedReasonIds = (0, _get2["default"])(call, 'selectedReasonIds') || [];
      var selectedSegmentId = (0, _get2["default"])(call, 'selectedSegmentId');
      var selectedSegment = (0, _find2["default"])(segments, {
        value: selectedSegmentId
      });
      var noteId = (0, _get2["default"])(note, 'id');
      var isPinned = (0, _get2["default"])(note, 'isPinned');
      var noteText = (0, _get2["default"])(note, 'text');
      var groupCount = (0, _get2["default"])(group, 'count');
      var groupMessenger = (0, _get2["default"])(group, 'messenger');
      var isBotEmail = (0, _get2["default"])(email, 'isBot');
      var editable = (0, _get2["default"])(call || note, 'editable');
      var isActive = !finishedAt && type === _constants.CLIENT_LOG_TYPES.CALL;
      var isSelected = String(selectedCallId) === String(callId) && type === _constants.CLIENT_LOG_TYPES.CALL;
      var isEditable = editable && !isEditableExpired;
      var isEditableCall = type === _constants.CLIENT_LOG_TYPES.CALL && isEditable && !(0, _isEmpty2["default"])(reasons);
      var isEditableButHasNoReasons = isEditableCall && !isEditing && (0, _isEmpty2["default"])(selectedReasonIds);
      var isIconClickable = type === _constants.CLIENT_LOG_TYPES.EMAIL && (ticketId || isBotEmail);
      var duration = (0, _date.getCallDuration)(answeredAt, finishedAt);
      var content;
      switch (type) {
        case _constants.CLIENT_LOG_TYPES.CALL:
          content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledHead, null, isActive && duration >= 0 && /*#__PURE__*/_react["default"].createElement(StyledTimer, {
            initialSeconds: duration
          }), !isActive && /*#__PURE__*/_react["default"].createElement(StyledDuration, {
            duration: duration
          }), name && /*#__PURE__*/_react["default"].createElement(StyledName, {
            name: name
          })), time && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
            full: true,
            extend: true,
            time: time
          }), recordUrl && /*#__PURE__*/_react["default"].createElement("a", {
            href: recordUrl,
            target: "_blank",
            title: "\u041F\u0440\u043E\u0441\u043B\u0443\u0448\u0430\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C"
          }, /*#__PURE__*/_react["default"].createElement(StyledRecordIcon, null)), selectedSegment && /*#__PURE__*/_react["default"].createElement(StyledSegment, null, selectedSegment.title), !(0, _isEmpty2["default"])(reasons) && this.reasonListRenderer(isEditableCall), reasonDescription && /*#__PURE__*/_react["default"].createElement(StyledReasonsDescription, null, reasonDescription));
          break;
        case _constants.CLIENT_LOG_TYPES.EMAIL:
          content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, text && /*#__PURE__*/_react["default"].createElement(StyledText, {
            title: text
          }, text), time && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
            full: true,
            extend: true,
            time: time
          }), name && /*#__PURE__*/_react["default"].createElement(StyledName, {
            name: name
          }), read && /*#__PURE__*/_react["default"].createElement(StyledReadStatus, null), ticketId && /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
            id: ticketId,
            type: ticketType
          }));
          break;
        case _constants.CLIENT_LOG_TYPES.NOTE:
          content = /*#__PURE__*/_react["default"].createElement(StyledNoteContainer, null, /*#__PURE__*/_react["default"].createElement(StyledInfo, null, /*#__PURE__*/_react["default"].createElement(StyledMeta, null, name && /*#__PURE__*/_react["default"].createElement(StyledName, {
            name: name
          }), time && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
            full: true,
            extend: true,
            time: time
          })), !isPinned && /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
            functional: true,
            title: "\u0417\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C",
            onClick: this.togglePin
          }, /*#__PURE__*/_react["default"].createElement(_iconsReact.Pin, {
            height: 15
          })), isEditable && !isEditing && /*#__PURE__*/_react["default"].createElement(StyledDeleteButton, {
            functional: true,
            title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
            onClick: this.handleDelete
          }, /*#__PURE__*/_react["default"].createElement(StyledDeleteIcon, null))), /*#__PURE__*/_react["default"].createElement(StyledNote, {
            id: noteId,
            name: name,
            onEdit: this.handleNoteEdit,
            onToggleEdit: this.toggleEdit,
            readOnly: !isEditable,
            time: time,
            value: noteText
          }));
          break;
        case _constants.CLIENT_LOG_TYPES.MESSAGE:
        case _constants.CLIENT_LOG_TYPES.SMS:
          content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, text && /*#__PURE__*/_react["default"].createElement(StyledText, {
            title: text
          }, text), time && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
            full: true,
            extend: true,
            time: time
          }), name && /*#__PURE__*/_react["default"].createElement(StyledName, {
            name: name
          }));
          break;
        case _constants.CLIENT_LOG_TYPES.MESSAGE_GROUP:
          content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledText, null, groupCount, " ", (0, _userflow.pluralize)(groupCount, MESSAGE_COUNT_PLURALIZE)), /*#__PURE__*/_react["default"].createElement(StyledMetaText, null, name ? /*#__PURE__*/_react["default"].createElement(StyledHighlight, null, name) : 'Клиент ', "\u043E\u0441\u0442\u0430\u0432\u0438\u043B/\u0430 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435"), time && /*#__PURE__*/_react["default"].createElement(_TimeFrom["default"], {
            full: true,
            extend: true,
            time: time
          }), ticketId && /*#__PURE__*/_react["default"].createElement(StyledTicketType, {
            id: ticketId,
            type: ticketType
          }));
          break;
        default:
          // TODO: Need to add empty card for communication without type.
          content = null;
          break;
      }
      return /*#__PURE__*/_react["default"].createElement(StyledCommunicationWrapper, (0, _extends2["default"])({
        ref: this.wrapperRef
      }, props), /*#__PURE__*/_react["default"].createElement(StyledCommunication, {
        ref: this.communicationRef,
        isSelected: isSelected
      }, /*#__PURE__*/_react["default"].createElement(StyledTimeline, {
        offset: isEditableButHasNoReasons ? 62 : 0
      }, /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
        functional: true,
        disabled: !isIconClickable,
        onClick: this.handleIconClick
      }, /*#__PURE__*/_react["default"].createElement(StyledTypeIcon, {
        href: callUrl,
        isActive: isActive,
        isAnswered: Boolean(isAnswered),
        isCallback: Boolean(isCallback),
        isIncoming: Boolean(isIncoming),
        isBot: Boolean(isBotEmail),
        onPin: this.togglePin,
        pinned: Boolean(isPinned),
        type: type,
        messengerType: groupMessenger
      }))), /*#__PURE__*/_react["default"].createElement(StyledContent, null, content), isEditableButHasNoReasons && /*#__PURE__*/_react["default"].createElement(StyledReasonAdd, {
        onClick: this.toggleEdit
      }, "\u0423\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0438\u0447\u0438\u043D\u0443 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F")), isEditableCall && isEditing && /*#__PURE__*/_react["default"].createElement(StyledReasons, {
        className: CLASS_NAME_POPED_FORM,
        description: reasonDescription,
        groups: reasonGroups,
        onClickOutside: this.toggleEdit,
        onSubmit: this.handleReasonsSubmit,
        reasons: reasons,
        ref: this.reasonsRef,
        requireNoteIds: requireNoteIds,
        segments: segments,
        selectedGroupId: selectedReasonGroupId,
        selectedReasonIds: selectedReasonIds,
        selectedSegmentId: selectedSegmentId
      }));
    }
  }]);
}(_react["default"].PureComponent);
ClientLog.defaultProps = defaultProps;
var StyledCommunicationWrapper = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledCommunicationWrapper",
  componentId: "sc-wz8szj-0"
})(["display:block;"]);
var StyledInfo = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledInfo",
  componentId: "sc-wz8szj-1"
})(["display:flex;font-size:12px;color:#919499;margin-bottom:4px;"]);
var StyledMeta = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledMeta",
  componentId: "sc-wz8szj-2"
})(["display:flex;flex:1;flex-direction:column;"]);
var StyledCallIcon = (0, _styledComponents["default"])(_CallIcon["default"]).withConfig({
  displayName: "ClientLog__StyledCallIcon",
  componentId: "sc-wz8szj-3"
})(["svg > *{fill:none;stroke:#919499;}", ""], function (_ref3) {
  var isActive = _ref3.isActive,
    isCallback = _ref3.isCallback;
  return isActive && !isCallback && "\n    svg > * {\n      fill: #00c253;\n      stroke: #00c253;\n    }\n  ";
});
var StyledIconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientLog__StyledIconButton",
  componentId: "sc-wz8szj-4"
})(["display:flex;outline:none;", ""], function (_ref4) {
  var disabled = _ref4.disabled;
  return !disabled && "\n    &:hover path { stroke: #007aff; }\n  ";
});

// @ts-ignore
var StyledDeleteButton = (0, _styledComponents["default"])(StyledIconButton).withConfig({
  displayName: "ClientLog__StyledDeleteButton",
  componentId: "sc-wz8szj-5"
})(["margin-left:10px;"]);
var StyledDeleteIcon = (0, _styledComponents["default"])(_iconsReact.Close).withConfig({
  displayName: "ClientLog__StyledDeleteIcon",
  componentId: "sc-wz8szj-6"
})(["width:12px;height:12px;"]);
var StyledTypeIcon = (0, _styledComponents["default"])(function (_ref5) {
  var isActive = _ref5.isActive,
    isAnswered = _ref5.isAnswered,
    isBot = _ref5.isBot,
    isCallback = _ref5.isCallback,
    isIncoming = _ref5.isIncoming,
    onPin = _ref5.onPin,
    isPinned = _ref5.pinned,
    type = _ref5.type,
    messengerType = _ref5.messengerType,
    props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded2);
  var icon;
  switch (type) {
    case _constants.CLIENT_LOG_TYPES.CALL:
      icon = /*#__PURE__*/_react["default"].createElement(StyledCallIcon, {
        isActive: isActive,
        isAnswered: isAnswered,
        isCallback: isCallback,
        isIncoming: isIncoming
      });
      break;
    case _constants.CLIENT_LOG_TYPES.EMAIL:
      icon = isBot ? /*#__PURE__*/_react["default"].createElement(_communication.Bot, null) : /*#__PURE__*/_react["default"].createElement(_communication.Mail, null);
      break;
    case _constants.CLIENT_LOG_TYPES.NOTE:
      {
        icon = isPinned ? /*#__PURE__*/_react["default"].createElement(StyledPinButton, {
          onClick: onPin,
          title: "\u041E\u0442\u043A\u0440\u0435\u043F\u0438\u0442\u044C"
        }, /*#__PURE__*/_react["default"].createElement(StyledPin, null)) : /*#__PURE__*/_react["default"].createElement(StyledNoteIcon, null);
        break;
      }
    case _constants.CLIENT_LOG_TYPES.MESSAGE:
    case _constants.CLIENT_LOG_TYPES.SMS:
      icon = /*#__PURE__*/_react["default"].createElement(_communication.Message, null);
      break;
    case _constants.CLIENT_LOG_TYPES.MESSAGE_GROUP:
      icon = /*#__PURE__*/_react["default"].createElement(_Messenger["default"], {
        type: messengerType
      });
      break;
    default:
      return null;
  }
  return /*#__PURE__*/_react["default"].cloneElement(icon, props);
}).withConfig({
  displayName: "ClientLog__StyledTypeIcon",
  componentId: "sc-wz8szj-7"
})(["background-color:#e6e6e6;box-sizing:content-box;height:17px;margin-top:12px;padding:4px 0;z-index:2;width:17px;"]);
var StyledCommunication = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledCommunication",
  componentId: "sc-wz8szj-8"
})(["background-color:#e6e6e6;display:flex;padding:10px;box-sizing:border-box;position:relative;width:100%;font-size:14px;border-radius:6px;flex-wrap:wrap;", ""], function (_ref6) {
  var isSelected = _ref6.isSelected;
  return isSelected && "\n    border-top: 1px solid #e6e6e6;\n    background-color: #fff;\n    \n    ".concat(StyledTypeIcon, " {\n      background-color: #fff;\n    }\n  ");
});
var StyledReasons = (0, _styledComponents["default"])(_CallReasons["default"]).withConfig({
  displayName: "ClientLog__StyledReasons",
  componentId: "sc-wz8szj-9"
})(["background-color:#fff;display:flex;box-sizing:border-box;padding:10px 0;position:relative;width:100%;font-size:14px;border-radius:6px;flex-wrap:wrap;z-index:5;"]);
var StyledReason = (0, _styledComponents["default"])(_CallReason["default"]).withConfig({
  displayName: "ClientLog__StyledReason",
  componentId: "sc-wz8szj-10"
})(["margin-top:5px;"]);
var StyledSegment = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledSegment",
  componentId: "sc-wz8szj-11"
})(["margin-top:5px;"]);
var StyledReasonsDescription = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledReasonsDescription",
  componentId: "sc-wz8szj-12"
})(["margin-top:5px;"]);
var StyledHead = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledHead",
  componentId: "sc-wz8szj-13"
})(["display:flex;margin-top:4px;"]);
var StyledTimeline = exports.StyledTimeline = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledTimeline",
  componentId: "sc-wz8szj-14"
})(["display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:32px;:before{background-color:#c2c5cc;content:'';height:100%;left:50%;margin-left:-1px;position:absolute;top:0;width:1px;}", ""], function (_ref7) {
  var offset = _ref7.offset;
  return offset && "\n    height: calc(100% - ".concat(offset, "px);\n  ");
});
var StyledPinButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientLog__StyledPinButton",
  componentId: "sc-wz8szj-15"
})(["z-index:2;width:17px;height:17px;border:none;padding:4px 0;margin-top:12px;line-height:normal;box-sizing:content-box;background-color:#e6e6e6;"]);
var StyledPin = (0, _styledComponents["default"])(_communication.Pinned).withConfig({
  displayName: "ClientLog__StyledPin",
  componentId: "sc-wz8szj-16"
})(["path{fill:none;}&:hover path{stroke:#007aff;}"]);
var StyledNoteIcon = (0, _styledComponents["default"])(_communication.Note).withConfig({
  displayName: "ClientLog__StyledNoteIcon",
  componentId: "sc-wz8szj-17"
})(["margin-top:13px;"]);
var StyledContent = exports.StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledContent",
  componentId: "sc-wz8szj-18"
})(["color:#4d4d4d;display:flex;flex-direction:column;margin-left:22px;min-height:30px;position:relative;width:100%;"]);
var StyledText = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledText",
  componentId: "sc-wz8szj-19"
})(["display:inline-block;margin-right:5px;height:auto;"]);
var StyledHighlight = _styledComponents["default"].span.withConfig({
  displayName: "ClientLog__StyledHighlight",
  componentId: "sc-wz8szj-20"
})(["color:#007aff;margin-right:3px;font-weight:normal;"]);
var StyledMetaText = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledMetaText",
  componentId: "sc-wz8szj-21"
})(["display:inline-block;margin-right:5px;height:auto;font-size:13px;color:#919499;"]);
var StyledDuration = (0, _styledComponents["default"])(_Duration["default"]).withConfig({
  displayName: "ClientLog__StyledDuration",
  componentId: "sc-wz8szj-22"
})(["font-size:14px;"]);
var StyledTimer = (0, _styledComponents["default"])(_Timer["default"]).withConfig({
  displayName: "ClientLog__StyledTimer",
  componentId: "sc-wz8szj-23"
})(["font-size:14px;font-variant-numeric:tabular-nums;font-weight:normal;letter-spacing:-0.5px;"]);
var StyledNote = (0, _styledComponents["default"])(_Note["default"]).withConfig({
  displayName: "ClientLog__StyledNote",
  componentId: "sc-wz8szj-24"
})([""]);
var StyledTicketType = (0, _styledComponents["default"])(_TicketType["default"]).withConfig({
  displayName: "ClientLog__StyledTicketType",
  componentId: "sc-wz8szj-25"
})(["margin-top:5px;"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "ClientLog__StyledName",
  componentId: "sc-wz8szj-26"
})(["color:#479df4;font-size:13px;font-weight:400;flex:1;", " + &,", " + &{margin-left:5px;}"], StyledDuration, StyledTimer);
var StyledReadStatus = (0, _styledComponents["default"])(_communication.Read).withConfig({
  displayName: "ClientLog__StyledReadStatus",
  componentId: "sc-wz8szj-27"
})(["height:12px;position:absolute;right:0;top:2px;width:20px;"]);
var StyledRecordIcon = (0, _styledComponents["default"])(_communication.Record).withConfig({
  displayName: "ClientLog__StyledRecordIcon",
  componentId: "sc-wz8szj-28"
})(["cursor:pointer;height:23px;position:absolute;right:0;top:0;width:22px;"]);
var StyledReasonAdd = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "ClientLog__StyledReasonAdd",
  componentId: "sc-wz8szj-29"
})(["background-color:#007aff;border-radius:4px;color:#ffffff;font-size:14px;margin-top:10px;width:100%;&:hover{color:#ffffff;}"]);
var StyledNoteContainer = _styledComponents["default"].div.withConfig({
  displayName: "ClientLog__StyledNoteContainer",
  componentId: "sc-wz8szj-30"
})(["background-color:#fffbe5;border-radius:4px;", "{padding:10px 10px 0;}", "{padding:0 10px 10px;background:#fffbe5;border-radius:4px;box-shadow:0px 2px 2px rgb(230 230 230);}"], StyledInfo, StyledNote);
var _default = exports["default"] = ClientLog;